import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

type Props = {
  name?: string
  link?: string
  description?: string
}

export const PopupContent: React.FC<Props> = ({ name, link, description }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      {name && (
        <Heading className={styles.Title} like="h3">
          <Raw html={name} />
        </Heading>
      )}

      {link && (
        <Link className={styles.Link} href={link} view="arrow">
          <Raw html={t("indexes-and-ratings.List.Popup.Link")} />
        </Link>
      )}

      {description && <div dangerouslySetInnerHTML={{ __html: description }} />}
    </div>
  )
}
